// pages/GetStartedPage.js
import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../context/AppContext";
import { Button, Progress, Badge, Row, Col } from "reactstrap";
import listIcon from "../../assets/images/list-icon.png"
import Image from "../../components/Image";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export default function GetStartedPage() {
  const { tasks, progress, startTaskTour, fetchUserOnboardingStatus, quickStartOpen, quickStartEligible, openQuickStart, isCompleted } = useAppContext();
  const [onboardingStatusLoaded, setOnboardingStatusLoaded] = useState(false);
  const promptStartHighlightShown = useRef(false);

  const noTourCompleted = tasks.every(task => !task.completed);
  const agentStepsDone = tasks.filter(task => task.apiKey === "prompt" || task.apiKey === "agent").every(task => task.completed);


  useEffect(() => {
    const currentUserId = localStorage.getItem("userId");

    setTimeout(async () => {
      await fetchUserOnboardingStatus(currentUserId);
      setOnboardingStatusLoaded(true);
    }, 1000);
  }, []);

  useEffect(() => {
    // Wait while the quick-start pop-up is open or about to open by itself.
    if (!onboardingStatusLoaded || !noTourCompleted || promptStartHighlightShown.current || quickStartOpen || quickStartEligible) {
      return;
    }

    const timer = setTimeout(() => {
      const promptStartButton = document.getElementById("prompt-start-tour-btn");

      if (!promptStartButton) return;

      promptStartHighlightShown.current = true;

      const driverObj = driver({
        allowClose: true,
        overlayClickToExit: false,
        overlayOpacity: 0.5,
        showButtons: [],
        steps: [
          {
            element: "#prompt-start-tour-btn",
            popover: {
              title: "Start with your first prompt",
              description: "Click Start to begin creating your first prompt.",
              side: "left",
              align: "center"
            }
          }
        ]
      });

      driverObj.drive();
    }, 300);

    return () => clearTimeout(timer);
  }, [onboardingStatusLoaded, noTourCompleted, quickStartOpen, quickStartEligible]);



  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid py-3">
          <Row className="my-2 align-items-center">
            <Col md={8}>
              <h4>Getting Started</h4>
              <p className='text-muted fs-12'>Begin your journey with our comprehensive Getting Started guide.</p>
            </Col>
          </Row>
          <div
            className="p-4 rounded-4 text-white mb-4"
            style={{
              background: "var(--wr-gradient-brand)",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="mb-0 text-white">Let's get started</h4>
              <span className="fw-semibold fs-18">{Math.round(progress)}%</span>
            </div>
            <Progress
              value={progress}
              className="mt-2 custom-progress bg-white"
              height="15"
            />
          </div>

          {!isCompleted && !agentStepsDone && (
            <div className="qs-start-card mb-4">
              <div className="qs-orb" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span></div>
              <div className="flex-grow-1">
                <h4 className="mb-1">Hear your AI agent in 60 seconds</h4>
                <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                  Give us your website and pick a voice. We’ll build your first agent and you can talk to it right away.
                </p>
              </div>
              <button
                onClick={() => openQuickStart({ skipWelcome: true })}
                className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn text-nowrap"
              >
                Try the quick-start
              </button>
            </div>
          )}

          {/* Tasks Section */}
          <div className="d-flex flex-column gap-3">
            {tasks.map((task) => (
              <div
                key={task.id}
                className="d-flex justify-content-between align-items-center bg-white rounded-3 shadow-sm px-4 py-3"
                style={{
                  border: "1px solid #e9ecef",
                  transition: "0.2s ease",
                }}
              >
                {/* Left Side */}
                <div className="d-flex align-items-start gap-3">
                  {/* Checkbox Circle */}
                  <div>
                    {task.completed ? <Image src={listIcon} alt="Task" className='rounded-circle me-2 mt-1' height='23px' width='23px' objectFit='cover' />
                      :
                      <div className="empty-check-box me-2 mt-1"></div>
                    }
                  </div>

                  {/* Text Content */}
                  <div>
                    <h4 className="mb-1">{task.title}</h4>
                    <p className="text-muted mb-1" style={{ fontSize: "0.9rem" }}>
                      {task.description || ""}
                    </p>
                  </div>
                </div>

                {/* Right Side */}
                <div>
                  {task.completed ? (
                    <button
                      color="light"
                      className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white border-0"
                      style={{ backgroundColor: "#939393" }}
                    >
                      Completed
                    </button>
                  ) : (
                    <button
                      id={task.id === 1 ? "prompt-start-tour-btn" : undefined}
                      onClick={() => startTaskTour(task.id)}
                      className="font-normal py-2 px-5 rounded fs-16 text-decoration-none text-white linear-gradient-btn"
                    >
                      Start
                    </button>

                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
